import SignatureViewState from '../../store/schema/SignatureViewState';
import { action } from 'satcheljs';

/**
 * Action to update the signature view state in the event of a change
 * @param newViewState : The set of properties changed
 */
const updateSignatureViewState = action(
    'updateSignatureViewState',
    (changes: SignatureViewState) => ({ changes })
);

export default updateSignatureViewState;
